exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linked-answer-title[data-v-418e4956] {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  cursor: pointer;\n  padding-right: 28px;\n}\n.linked-answer-actions[data-v-418e4956] {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f3f4f6;\n}\n.open-answer-link[data-v-418e4956] {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--primary);\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n}\n.open-answer-link[data-v-418e4956]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
